import DocumentFormatPattern from '@/domain/models/document-format-pattern-model'

const GenericDocumentFormatPattern: DocumentFormatPattern<RegExp> = {
  normalize: (value: string) => value.trim(),
  mask: /^[\w|.-]{0,16}$/,
  prepareChar: str => str.toUpperCase(),
  placeholder: '00000000',
  blocks: {},
  validate: (value?: string): boolean => {
    return !!(
      value &&
      value.length > 7 &&
      value.length < 17 &&
      GenericDocumentFormatPattern.mask.test(value)
    )
  },
  isValid: (value?: string): boolean => {
    return GenericDocumentFormatPattern.validate?.(value) === true
  },
  rules: {
    minLength: {
      value: 8,
      message: 'Insira pelo menos 8 caracteres neste campo'
    },
    maxLength: {
      value: 16,
      message: 'Insira no máximo 16 caracteres neste campo'
    }
  }
}
export default GenericDocumentFormatPattern
